import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  withCredentials: true, // send HttpOnly auth cookie automatically
});

// Attach impersonation token when admin is impersonating a user
api.interceptors.request.use((config) => {
  const impToken = sessionStorage.getItem('ip_impersonate_token');
  if (impToken) config.headers.Authorization = `Bearer ${impToken}`;
  return config;
});

let logoutInProgress = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url    = error.config?.url || '';
    const isPublicAuthCall = /\/(login|register|forgot-password|reset-password|verify-email)/.test(url);
    // /auth/me returning 401 just means the visitor is a guest — don't redirect, let AuthContext handle it
    const isSessionCheck = url.includes('/auth/me');

    if (status === 401 && !isPublicAuthCall && !isSessionCheck && !logoutInProgress) {
      logoutInProgress = true;
      sessionStorage.removeItem('ip_impersonate_token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
      setTimeout(() => { logoutInProgress = false; }, 3000);
    }

    return Promise.reject(error);
  }
);

export default api;
